import { Text } from '../../../components/primitives';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { DEFAULT_PRODUCT_KIND, type OrganizationProduct } from '../types';

interface ProductKindAliasesSummaryProps {
  testID: string;
  product: Pick<OrganizationProduct, 'kind' | 'aliases'>;
}

export function ProductKindAliasesSummary({
  testID,
  product,
}: Readonly<ProductKindAliasesSummaryProps>) {
  const { t } = useTranslation();
  const aliases = product.aliases ?? [];
  const parts = [t(`onboardingWizard.products.kind.${product.kind ?? DEFAULT_PRODUCT_KIND}`)];
  if (aliases.length > 0) {
    parts.push(`${t('onboardingWizard.products.aliases.alsoKnownAs')} ${aliases.join(', ')}`);
  }

  return (
    <Text testID={testID} variant="caption" color={colors.text.secondary}>
      {parts.join(' · ')}
    </Text>
  );
}
